import styled from 'styled-components';

export const Styled = styled.div`
    .option-row {
        height: auto;

        .name-col {
            overflow: hidden;
            font-weight: 500;
            line-height: 145%;
            color: #141414;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        
        .detail-col {
            top: 2px;
            overflow: hidden;
            font-size: 12px;
            font-weight: 400;
            line-height: 145%;
            color: #595959;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
`;

export const StyledPhoneNumberInputV3Wrapper = styled.div`
    input.ant-input { // the phone number input
        border-start-end-radius: ${props => (props.hasActions ? 0 : '')};
        border-end-end-radius: ${props => (props.hasActions ? 0 : '')};
    }

    .action-button-wrapper {
        .ant-btn {
            padding: 4px 8px;
            color: rgba(0, 0, 0, 0.45);
            border-left: 0;
            border-start-start-radius: 0;
            border-end-start-radius: 0;
        }

        .ant-btn-default:disabled {
            color: rgba(0, 0, 0, 0.25);
        }
    }

    .ant-input.ant-custom-readonly { // country code select readonly
        border: none;
        background: transparent;
        min-height: 30px;
    }
`;
